import {
  getGretaAIChatRenderableTurns,
  getIsGretaAIChatUserRole,
} from '../../GretaAIChatMessage'

export function getIsGretaAIChatLastTurnQuestion(messages, question) {
  const lastTurn = getGretaAIChatRenderableTurns(messages).at(-1)

  return (
    Boolean(question) &&
    getIsGretaAIChatUserRole(lastTurn?.role) &&
    lastTurn.text.trim() === question
  )
}
